/**
 * BasicInfoTab — Corporation details and campuses list.
 */

import { Link } from 'react-router-dom';
import { formatPhone } from '../../../../../libs.jsx';

const BasicInfoTab = ({
  corpData, editRights, addRights, onEdit, onAddCampus,
}) => {
  const campuses = corpData?.campuses || [];

  return (
    <>
      {/* Corporation Details */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Corporation Details</h3>
          <div className="pp-section__actions">
            {editRights && (
              <button className="dp-btn dp-btn--secondary dp-btn--sm" onClick={onEdit}>
                ✎ Edit
              </button>
            )}
          </div>
        </div>
        <div className="pp-section__body">
          <div className="pp-field-grid">
            <div className="pp-field">
              <span className="pp-field__label">Corporate Name</span>
              <span className="pp-field__value">{corpData?.corporate_name || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Corporate GUID</span>
              <span className="pp-field__value pp-field__value--mono">
                {corpData?.corporate_guid || '—'}
              </span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Country</span>
              <span className="pp-field__value">{corpData?.country || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Street Address</span>
              <span className="pp-field__value">{corpData?.street_address || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">City</span>
              <span className="pp-field__value">{corpData?.city || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">State</span>
              <span className="pp-field__value">{corpData?.state || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Zip Code</span>
              <span className="pp-field__value">{corpData?.zip || corpData?.zipcode || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Email</span>
              <span className="pp-field__value">{corpData?.email || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Phone</span>
              <span className="pp-field__value">
                {corpData?.phone ? formatPhone(corpData.phone) : '—'}
              </span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Lat / Long</span>
              <span className="pp-field__value">
                {corpData?.latitude || '?'} / {corpData?.longitude || '?'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Campuses */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">
            Campuses
            <span className="pp-section__count">({campuses.length})</span>
          </h3>
          <div className="pp-section__actions">
            {addRights && (
              <button className="dp-btn dp-btn--primary dp-btn--sm" onClick={onAddCampus}>
                <svg className="dp-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add Campus
              </button>
            )}
          </div>
        </div>
        <div className="pp-section__body">
          {campuses.length > 0 ? (
            <div className="crpp-campuses-list">
              {campuses.map((c, idx) => (
                <Link
                  key={c.campus_id || idx}
                  to={`/profiles/campus/${c.campus_id}`}
                  className="crpp-campus-chip"
                >
                  {c.campus_name || `Campus ${c.campus_id}`}
                </Link>
              ))}
            </div>
          ) : (
            <span className="dp-cell-text dp-cell-text--muted">No campuses</span>
          )}
        </div>
      </div>
    </>
  );
};

export default BasicInfoTab;
